import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container';

import '../styles/Footer.css'; 

function Footer(props) {
    const { t } = useTranslation()

   


    useEffect(() => {
     
     
    }, [props.lang])
    return (


        <div className="footer" >
          
      <Row style={{marginLeft: "15px", marginRight: "15px"}}> 
        <Col sm={8} lg={8}>
    
        <img key={props.lang} height='60px' style={{marginTop:"1rem", marginBottom:"2rem"}}src={`https://www.fao.org/images/corporatelibraries/fao-logo/fao-sdg/fao-logo-sdg-${props.lang}.svg?sfvrsn=350c54f1_28`} alt="FAO logo with sustainable development goals" />
     <Row>
        <div style={{display: "flex", flexDirection: "horizontal"}}>  
        {/* <Col style={{maxWidth: "250px"}}> */}
         
           <span  className="footer-org-chart" style={{paddingLeft: props.lang === "ar" ? "5rem" : "0rem", paddingRight: props.lang === "ar" ? "0rem" : "5rem"}}> 

       <a    href={`https://www.fao.org/about/org-chart/${props.lang}`}  target="_blank" rel="noreferrer"><span>{t('footer_Fao_organizational_chart')}</span></a>
        </span> 
     
       {/* </Col>
       <Col > */}
      <span >
         <DropdownButton
        
         variant="transparent"
        //  className='footer-span'
              key="up"
              id={`dropdown-button-drop-up`}
              drop="up"
              style = {{  borderRadius: '2rem', boxShadow: 'none'}}
              title={ <span style={{  color:" #116AAB",fontSize: "0.9rem", fontWeight: "350"}} >
                 {t('footer_worldwide_offices')}<img style={{ paddingLeft: "0.1rem", paddingRight: "1rem"}}src={process.env.PUBLIC_URL + `/img/chevron-up.svg`} alt="share icon" />
                </span>}>
             
              <Dropdown.Item target="_blank" rel="noreferrer" href={`https://www.fao.org/africa/${props.lang}`}>{t('footer_africa_office')}</Dropdown.Item>
              <Dropdown.Item target="_blank" rel="noreferrer" href={`https://www.fao.org/asiapacific/${props.lang}`}>{t('footer_asia_pacific_office')}</Dropdown.Item>
              <Dropdown.Item target="_blank" rel="noreferrer" href={`https://www.fao.org/europe/${props.lang}`}>{t('footer_europe_office')}</Dropdown.Item>
              <Dropdown.Item target="_blank" rel="noreferrer" href={`https://www.fao.org/americas/${props.lang}`}>{t('footer_latin_office')}</Dropdown.Item>
              <Dropdown.Item target="_blank" rel="noreferrer"href={`https://www.fao.org/neareast/${props.lang}`}>{t('footer_near_east_offices')}</Dropdown.Item>
              <Dropdown.Item target="_blank" rel="noreferrer" href={`https://www.fao.org/about/who-we-are/worldwide-offices/${props.lang}/#c207632`}>{t('footer_country_offices')}</Dropdown.Item>
             </ DropdownButton> 
             </span>
             {/* </Col> */}
            </div>
               </Row> 
                <Container style={{  borderTop: "2px solid #F2F2F2"}}>
                 
                     
                        <span style={{ paddingRight:"3px", borderRight: "2px solid #F2F2F2"}}><a style={{ color:"#116AAB", fontSize:"14px" , textDecoration: "none"}} 
                        href={`https://www.fao.org/contact-us/${props.lang}`}  target="_blank ">{t('footer_jobs')}</a></span>
            
           
                 <span style={{ paddingRight:"3px",   borderRight: "2px solid #F2F2F2"}}> 
                  <a style={{ color:"#116AAB", marginLeft:"5px", fontSize:"14px" , textDecoration: "none"}} href={`https://www.fao.org/contact-us/${props.lang}`} 
                  target="_blank ">{t('footer_contact_us')}</a></span>
                  
                 
                 <span style={{ paddingRight:"3px", padddingLeft:"3px", borderRight: "2px solid #F2F2F2"}}>
                  <a style={{ color:"#116AAB", marginLeft:"5px", fontSize:"14px" , textDecoration: "none"}} 
                  href={`https://www.fao.org/contact-us/${props.lang}`} target="_blank ">{t('footer_terms_and_conditions')}</a></span>
            
                     <span style={{ paddingRight:"3px", marginLeft:"5px", padddingLeft:"3px",  borderRight: "2px solid #F2F2F2"}} className="footer-span-small"><a style={{ color:"#116AAB", fontSize:"14px" , textDecoration: "none"}} href={`https://www.fao.org/contact-us/${props.lang}`} target="_blank ">{t('footer_data_and_privacy')}</a></span>
           
                  <span style={{ paddingRight:"3px", padddingLeft:"3px",  borderRight: "2px solid #F2F2F2"}} className="footer-span-small">
                    <a style={{ color:"#116AAB", marginLeft:"5px", fontSize:"14px" , textDecoration: "none"}} href={`https://www.fao.org/contact-us/${props.lang}`} target="_blank ">{t('footer_scam_alert')}</a></span>
             
                </Container>
                <Container >
                <Row style={{paddingLeft: "0px", paddingRight: "0px"}}>
                  <Col style={{ marginBottom:"2rem"}}>
                <span ><a style={{ color:"#116AAB", fontSize:"14px" , textDecoration: "none"}} href={`https://www.fao.org/contact-us/report-misconduct/${props.lang}`}  target="_blank ">{t('footer_report_misconduct')}</a></span></Col>
                </Row>
                </Container>

        </Col>
        <Col sm={4}>
        <div className="title-category">{t('footer_follow_us')}</div>
        <a className="footer-round_icon" href="https://www.facebook.com/UNFAO/?ref=mf" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="Facebook" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-facebook.svg?sfvrsn=b87ff153_3" alt="Facebook logo" /></a>

        <a  style={{paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}} href="https://www.flickr.com/photos/faonews/albums/" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="flickr" src="	https://www.fao.org/images/corporatelibraries/social-icons/social-icon-flickr.svg?sfvrsn=67ac8c4d_3" alt="Flickr logo" /></a>
        <a style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://www.instagram.com/fao/" target="_blank ">
        <img style={{paddingTop: "0.5rem"}} key="Instagram" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-instagram.svg?sfvrsn=a778452f_3" alt="Instagram logo" /></a>


        <a  style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://www.linkedin.com/company/fao/mycompany/verification/" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="LinkedIn" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-linkedin.svg?sfvrsn=1025492c_3" alt="LinkedIn logo" /></a>

        
        <a  style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://www.fao.org/home/en/#" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="rss" src="	https://www.fao.org/images/corporatelibraries/social-icons/social-icon-rss.svg?sfvrsn=2af5e01a_3" alt="rss logo" /></a>


        <a  style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://soundcloud.com/unfao" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="facebook" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-soundcloud.svg?sfvrsn=26e63892_3" alt="Soundcloud logo" /></a>

        <a  style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}} href="https://www.tiktok.com/@fao" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="TikTok" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-tiktok.svg?sfvrsn=b2228fd0_3" alt="TikTok logo" /></a>

        <a  style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://www.toutiao.com/c/user/token/MS4wLjABAAAAddfBLLYL2GZzXAetR_paFVV1-M4fdAWpUxiROxuOpl7pDGuXLCGfYg_VOogU135J/?wid=1696854437678" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="facebook" src="	https://www.fao.org/images/corporatelibraries/social-icons/social-icon-tuotiao.svg?sfvrsn=1883ae3_3" alt="Toutiao logo" /></a>


        <a  style={{ paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://www.fao.org/home/en/#" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="wechat" src="	https://www.fao.org/images/corporatelibraries/social-icons/social-icon-wechat.svg?sfvrsn=cd28c1ee_3" alt="WeChatlogo" /></a>


        <a  style={{paddingTop: "0.5rem", paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="http://www.weibo.com/unfao?from=myfollow_all" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="Weibo" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-weibo.svg?sfvrsn=7b5b0403_3" alt="Weibo logo" /></a>

        <a  style={{paddingTop: "0.5rem", paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://twitter.com/FAO" target="_blank ">
        <img style={{paddingTop: "0.5rem"}}  key="twitter" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-twitter.svg?sfvrsn=c68bb7c2_4" alt="Twitter logo" /></a>

        <a  style={{marginTop: "2rem", paddingTop: "0.5rem", paddingLeft: props.lang === "ar" ? "0rem" : "0.2rem", paddingRight: props.lang === "ar" ? "0.2rem" : "0rem"}}  href="https://www.youtube.com/user/FAOoftheUN" target="_blank ">
        <img style={{paddingTop: "0.5rem"}} key="youtube" src="https://www.fao.org/images/corporatelibraries/social-icons/social-icon-youtube.svg?sfvrsn=94de1814_3" alt="Youtube logo" /></a>

        <div style={{paddingTop: "1rem"}} className="title-category">{t('footer_download_our_app')}</div>
        <Container >
                    <Row style={{paddingTop: "1rem", paddingLeft: "0px", paddingRight: "0px"}}> 
                      <Col xs={6}>
                      <a  href="https://apps.apple.com/us/app/faonow/id877618174?ls=1" target="_blank ">
                  <img key="AppStore" src="https://www.fao.org/images/corporatelibraries/misc/app-store.svg?sfvrsn=1de5ebe_5" alt="Twitter logo" /></a>
                 </Col>
                 <Col  xs={6}> <a  href="https://play.google.com/store/games?hl=en&gl=US" target="_blank ">
        <img key="GooglePlay" src="https://www.fao.org/images/corporatelibraries/misc/google-play.svg?sfvrsn=fd50f104_5" alt="Youtube logo" /></a></Col>
                </Row>
                </Container>
          <div className="footer-at-fao">&#169; FAO, 2023</div></Col>
            
   
    </Row>
    </div>
    );}

    export default Footer;

